import React, { useEffect, useRef, useState } from 'react';
import FastbetDropdown from '../../common/FastbetDropdown';
import MoreBetsOdd from '../../common/MoreBetsOdd';
import PrematchContext from '../../contexts/PrematchContext';
import { isSeoSettingsNoFollow } from '../../data/seo/seoUtils';
import { useAbsolutePath } from '../../data/seo/seoRouteUtils';
import { getEncodedURI } from '../../data/utils';
import { checkForDashClass } from '../../tables-utils';
import { useUISettings } from '../../UISettingsProvider';
import MoreBets from './MoreBets';
import Jersey from '../../data/jerseys/Jersey';
import { BetslipSelectionsContext } from '../../data/betslip/BetslipSelectionsConf';
import StatsToggle from '../../common/StatsToggle';

function TournamentColumnBets(props) {
    const betslipSelectionsContext = React.useContext(BetslipSelectionsContext);
    const prematchContext = React.useContext(PrematchContext);
    const uiSettings = useUISettings();

    const [toggled, setToggled] = useState(prematchContext.match?.openedFromBanner ?? false);

    function handleClick(url) {
        if (uiSettings.fullScreen) {
            setToggled(!toggled);
        } else {
            props.openMatch(match, url, match.urlPath);
        }
    }

    function handleClickHref(url,e){
        e.preventDefault();
    }

    function toggleMoreBets() {
        if (uiSettings.fullScreen) {
            setToggled(!toggled);
        }
    }

    const match = props.match, agg = props.agg;
    const absoluteMatchPath = useAbsolutePath(match.urlPath, null, match.urlPathSeo);
    const noFollow = isSeoSettingsNoFollow(match.urlPathSeoSettings);
    const eventSelected = betslipSelectionsContext.isEventSelected(match.pal, match.avv);
    const matchId = `extended-bets-${match.uniqueId}`;
    const moreBetsToggled = uiSettings.fullScreen && toggled;

    const fiveColumnTemplate = (match?.gruppiScommessa.length <= 1  ?? false) && match.avvRef == null;

    // Adatta il nome del match in base allo spazio disponibile
    const matchDesc = useRef(null);
    useEffect(() => {
        const handler = () => {
            if (matchDesc.current != null) {
                checkForDashClass(matchDesc.current);
            }
        };

        handler();
        window.addEventListener('resize', handler);
        return () => {
            window.removeEventListener('resize', handler);
        }
    }, [uiSettings.fullScreen, props.aggregata]);

    return (
        <div className="contenitoreRiga" key={`tournament-match-${match.id}`}>
            <div className={"tabellaQuoteNew" +(eventSelected? " event-row-selected ":"") + " text_s1 tabellaQuotePrematch mb-2" + (fiveColumnTemplate ? ' tabellaQuotePrematch_5col' : ' ')}>
                <div className="tabellaQuoteAlias d-flex justify-content-center align-items-center">
                    <p>{match.alias}</p>
                </div>
                <div className="tabellaQuoteTempo d-flex justify-content-center align-items-center">
                    <p>
                        <span className="tabellaQuoteTempo__data">{match.date}</span>
                        <span className="tabellaQuoteTempo__separatore">-</span>
                        <span className="tabellaQuoteTempo__ora">{match.time}</span>
                    </p>
                </div>
                <div ref={matchDesc} className="tabellaQuoteSquadre pointer" onClick={handleClick.bind(this, absoluteMatchPath)}>
                    <a href={getEncodedURI(absoluteMatchPath)} onClick={handleClickHref.bind(this, absoluteMatchPath)} {...(noFollow ? {rel: 'nofollow'}:{})} ></a>
                    {props.showTournamentDesc &&
                        <p className="font-weight-bold m-0 text-right tournament-desc">
                            {match.tournamentDesc}
                        </p>
                    }
                    <div className="d-flex items-center">
                        {match.team2 &&
                            <Jersey data={match.jerseys?.[0]} type={'home'} sportRef={match.sportRef} />
                        }
                        <p className="font-weight-bold m-0 text-right" title={match.team1}>
                            {match.team1}
                        </p>
                    </div>
                    {match.team2 &&
                        <>
                            <p className="font-weight-bold colore-1 m-0 px-2 tabellaQuoteSquadreSeparatore">
                                {match.team2 == null ? '' : 'vs'}
                            </p>
                            <div className="d-flex items-center">
                                <Jersey data={match.jerseys?.[1]} type={'away'} sportRef={match.sportRef} />
                                <p className="font-weight-bold m-0 text-left" title={match.team2}>
                                    {match.team2}
                                </p>
                            </div>
                        </>
                    }
                </div>
                <div className="tabellaQuoteStatistiche">
                    <StatsToggle className="fas fa-chart-bar stat-sel pointer" match={match} />
                </div>
                {!fiveColumnTemplate &&
                    <div className="tabellaQuoteAltre d-flex justify-content-end align-items-center pr-2">
                        <FastbetDropdown id={match.id} match={match} moreBetsToggled={moreBetsToggled} toggleMoreBets={toggleMoreBets} />
                    </div>
                }
            </div>
            <div className="tabellaQuoteRisultatoEsattoEspandi pointer toggle-nascondi-live mb-2" data-toggle="collapse" href={`#${matchId}`} role="button" aria-expanded="true" aria-controls={matchId}>
                <p>{agg.descrizione}</p>
            </div>
            <div id={matchId} className="collapse show">
                <div className="risultatoEsattoGrid text_s1">
                    {agg.scommesse.filter(bet => bet.hasOdds).map(bet => {
                        return bet.odds.map((odd) => {
                            odd.addBetDesc = true;
                            const id = `${matchId}_${odd.betId}_${odd.betData.handicap}_${odd.id}`;
                            return (
                                <MoreBetsOdd key={id} {...odd} />
                            );
                        });
                    })}
                </div>
            </div>
            {moreBetsToggled &&
                <MoreBets match={match} aggregata={props.aggregata} />
            }
        </div>
    )
}

export default TournamentColumnBets;
